import { useViewerCurrency } from '@/api/hooks/shared/useViewerCurrency'
import { useSession } from '@/api/hooks/shared/useSession'
import {
  netExposureBookKindFromMarketType,
  netExposureDisplayCurrency,
  type NetExposureBookKind,
} from '@/features/net-exposure/netExposureDisplayCurrency'

/** Display currency for a Net Exposure book cell (Lab INR for POINTS agents on BF/BM). */
export function useNetExposureDisplayCurrency(
  bookKind: NetExposureBookKind | string,
): ReturnType<typeof useViewerCurrency> {
  const viewerCurrency = useViewerCurrency()
  const { data } = useSession()
  const role = data?.account.role ?? 'player'
  const kind =
    typeof bookKind === 'string' &&
    (bookKind === 'match' || bookKind === 'bookmaker' || bookKind === 'fancy' || bookKind === 'other')
      ? bookKind
      : netExposureBookKindFromMarketType(bookKind)
  return netExposureDisplayCurrency({
    viewerCurrency,
    viewerRole: role,
    bookKind: kind,
  })
}
